<script>
  export default {
    props: ['errors']
  }
</script>

<template>
  <div>
    <div v-for="(error,index) in errors" :key="'err'+index" class="alert alert-danger" aria-live="polite" aria-atomic="true" role="alert">
      {{index}} : {{error}}
    </div>
  </div>
</template>